import {
  AuthState,
  CONNECTION_STATUS,
  GET_ONLINE_CONFIG_REQUEST,
  GET_ONLINE_CONFIG_FAILURE,
  GET_ONLINE_CONFIG_SUCCESS,
  GET_LANGUAGES_REQUEST,
  GET_LANGUAGES_FAILURE,
  GET_LANGUAGES_SUCCESS,
  GET_LANGUAGE_REQUEST,
  GET_LANGUAGE_FAILURE,
  GET_LANGUAGE_SUCCESS,
  GET_JURISDICTIONS_REQUEST,
  GET_JURISDICTIONS_FAILURE,
  GET_JURISDICTIONS_SUCCESS,
  CLEAR_ONLINE_CONFIG_DEFAULT_FORM,
  CHANGE_LOCALE,
  EULA_ACCEPTED,
  SESSION_TIME_OUT,
  AUTH_STATE_REQUEST,
  AUTH_STATE_SUCCESS
} from 'actions';

import { getCookie } from 'common/cookies';

import messagesEn from 'assets/lang/en.json';
import EnvConfig from 'env.config';

function app(state = {
  isAuthenticated: false,
  isEulaAccepted: !!getCookie(EnvConfig.eulaCookieName),
  locale: 'en-US',
  languages: [{
    key: 'en',
    value: 'English'
  }],
  messages: messagesEn,
  isFetching: false,
  onlineConfig: null,
  dictionaryLoaded: false,
  jurisdictionsLoading: false,
  staticData: {
    jurisdictions: null,
    usTaxTreatyCountries: null
  },
  bypassEula: false,
  isOnline: true,
  retries: 0,
  connectionInfo: null,
  authState: AuthState.Unknown
}, action) {
  switch (action.type) {
    case CONNECTION_STATUS:
      return {
        ...state,
        connectionInfo: action.connectionInfo,
        isOnline: action.isOnline,
        retries: action.retries
      };
    case GET_ONLINE_CONFIG_REQUEST:
      return {
        ...state
      };
    case GET_ONLINE_CONFIG_SUCCESS:
      return {
        ...state,
        onlineConfig: action.onlineConfig,
        isAuthenticated: true
      };
    case GET_ONLINE_CONFIG_FAILURE:
      return {
        ...state,
        isFetching: false,
        bypassEula: true
      };
    case GET_LANGUAGES_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        languages: action.languages,
      };
    case GET_LANGUAGES_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case GET_LANGUAGE_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case GET_LANGUAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        locale: action.locale,
        messages: state.messages ? Object.assign(state.messages, action.messages) : action.messages,
        dictionaryLoaded: true
      };
    case GET_LANGUAGE_FAILURE:
      return {
        ...state,
        isFetching: false
      };
    case GET_JURISDICTIONS_REQUEST:
      return {
        ...state,
        jurisdictionsLoading: true
      };
    case GET_JURISDICTIONS_SUCCESS:
      return {
        ...state,
        jurisdictionsLoading: false,
        staticData: {
          ...state.staticData,
          jurisdictions: action.jurisdictions,
          usTaxTreatyCountries: action.usTaxTreatyCountries
        }
      };
    case GET_JURISDICTIONS_FAILURE:
      return {
        ...state,
        jurisdictionsLoading: false
      };
    case CHANGE_LOCALE:
      return {
        ...state,
        locale: action.locale
      };
    case EULA_ACCEPTED:
      return {
        ...state,
        isEulaAccepted: true
      };
    case CLEAR_ONLINE_CONFIG_DEFAULT_FORM:
      return {
        ...state,
        onlineConfig: {
          ...state.onlineConfig,
          defaultFormType: null
        }
      };
    case SESSION_TIME_OUT:
      return {
        ...state,
        isAuthenticated: false
      };
    case AUTH_STATE_REQUEST:
    case AUTH_STATE_SUCCESS:
      return {
        ...state,
        authState: action.authState
      };
    default:
      return state;
  }
}

export default app;
